makeErrorEnum = require 'lib/make-error-enum'
Plugin = require 'models/plugin'
PluginHandlers = require 'views/internal/plugins/plugin-handlers'
PluginIO = require 'views/internal/plugins/plugin-io'

PluginIOCacheError = makeErrorEnum 'PluginCache', [
  'InvalidArgument'
]

class PluginIOCache
  Error: PluginIOCacheError

  constructor: ->
    @pluginFromId = {}

  get: (plugin) ->
    if plugin !instanceof Plugin
      throw PluginIOCacheError.InvalidArgument("expected a plugin")

    id = plugin.id
    if (existingPlugin = @fromId(id))?
      return existingPlugin

    iframeConnectorUrl = plugin.get('iframeConnectorUrl')

    io = new PluginIO(
      plugin,
      PluginHandlers({
        idPlugin: id,
        allowRestricted:
          /^https:\/\/[\w-]+\.(?:staging\.)?trello\.services\//.test(iframeConnectorUrl) ||
          /^http:\/\/localhost:\d+\/[\w-]+\//.test(iframeConnectorUrl)
      })
    )

    @pluginFromId[id] = io
    io

  fromId: (id) ->
    @pluginFromId[id]

  drop: (idPlugin) ->
    if (plugin = @pluginFromId[idPlugin])?
      delete @pluginFromId[idPlugin]
      plugin.drop()

module.exports = new PluginIOCache()



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-io-cache.coffee